import AOS from "aos";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const TextMarqueSection = () => {
  useEffect(() => {
    document.querySelectorAll(".logos").forEach((logosContainer) => {
      const copy = logosContainer.querySelector(".logos-slide").cloneNode(true);
      logosContainer.appendChild(copy);
    });
  }, []);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <>
      <div
        className="header_full_sec about_header_full_sec"
        id="contact-ticker"
      >
        <div className="position-relative">
          {/* <img
            className="client-bounce-img client-bounce-img1"
            src={ClientBounceImg1}
            alt="client-bounce-img1"
          />
          <img
            className="client-bounce-img client-bounce-img2"
            src={ClientBounceImg2}
            alt="client-bounce-img2"
          />
          <img
            className="client-bounce-img client-bounce-img3"
            src={ClientBounceImg3}
            alt="client-bounce-img3"
          />
          <img
            className="client-bounce-img client-bounce-img4"
            src={ClientBounceImg4}
            alt="client-bounce-img4"
          /> */}
          <div className="logos">
            <div className="logos-slide">
              <div className="ticker__item">
                <Link to="mailto:info@marichitechai.com">
                  info@marichitechai.com
                </Link>
              </div>
              <div className="ticker__item ticker__item_dark">
                <Link to="tel:(+977) 9840540455">(+977) 9840540455</Link>
              </div>
              <div className="ticker__item">
                <Link to="mailto:info@marichitechai.com">
                  info@marichitechai.com
                </Link>
              </div>
              <div className="ticker__item ticker__item_dark">
                <Link to="tel:(+977) 9840540455">(+977) 9840540455</Link>
              </div>
              <div className="ticker__item">
                <Link to="mailto:info@marichitechai.com">
                  info@marichitechai.com
                </Link>
              </div>
              <div className="ticker__item ticker__item_dark">
                <Link to="tel:(+977) 9840540455">(+977) 9840540455</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TextMarqueSection;
